var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreVertical(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_306",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 24,
    width: 24,
    height: 24,
    transform: "rotate(-90 0.5 24)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 17.75C15 18.3687 14.7797 18.8984 14.3391 19.3391C13.8984 19.7797 13.3688 20 12.75 20C12.1313 20 11.6016 19.7797 11.1609 19.3391C10.7203 18.8984 10.5 18.3687 10.5 17.75C10.5 17.1312 10.7203 16.6016 11.1609 16.1609C11.6016 15.7203 12.1313 15.5 12.75 15.5C13.3688 15.5 13.8984 15.7203 14.3391 16.1609C14.7797 16.6016 15 17.1312 15 17.75ZM15 11C15 11.6187 14.7797 12.1484 14.3391 12.5891C13.8984 13.0297 13.3688 13.25 12.75 13.25C12.1313 13.25 11.6016 13.0297 11.1609 12.5891C10.7203 12.1484 10.5 11.6187 10.5 11C10.5 10.3813 10.7203 9.85156 11.1609 9.41094C11.6016 8.97031 12.1313 8.75 12.75 8.75C13.3688 8.75 13.8984 8.97031 14.3391 9.41094C14.7797 9.85156 15 10.3813 15 11ZM15 4.25C15 4.86875 14.7797 5.39844 14.3391 5.83906C13.8984 6.27969 13.3688 6.5 12.75 6.5C12.1313 6.5 11.6016 6.27969 11.1609 5.83906C10.7203 5.39844 10.5 4.86875 10.5 4.25C10.5 3.63125 10.7203 3.10156 11.1609 2.66094C11.6016 2.22031 12.1313 2 12.75 2C13.3688 2 13.8984 2.22031 14.3391 2.66094C14.7797 3.10156 15 3.63125 15 4.25Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreVertical);
export default __webpack_public_path__ + "static/media/moreVertical.6faa43147db54e47ede37463578034e4.svg";
export { ForwardRef as ReactComponent };